export default __webpack_public_path__ + "static/item_04-fdea84a384b8d909c81824e954702caf.jpg";